import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';
import logoImg from '../assets/onpoint-logo.png';
import langIcon from '../assets/lang-icon.png';
import arrowIcon from '../assets/arrow-down.png';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeNav, setActiveNav] = useState('home');
  const [isLangOpen, setIsLangOpen] = useState(false);

  const langRef = useRef(null);
  const navRef = useRef(null);

  useEffect(() => {
    const currentLang = i18n.language;
    document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;
  }, [i18n.language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setIsLangOpen(false);
      }
      if (
        isOpen &&
        navRef.current &&
        !navRef.current.contains(event.target) &&
        !event.target.closest('.hamburger')
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangOpen(false);
  };

  const navItems = [
    { id: 'home', label: t('nav.home'), path: 'https://technology.on-point-kw.com/', external: true },
    { id: 'about', label: t('nav.about'), path: 'https://technology.on-point-kw.com/en/about', external: true },
    { id: 'services', label: t('nav.services'), path: '#services', external: false },
    { id: 'blogs', label: t('nav.blogs'), path: 'https://technology.on-point-kw.com/en/blogs', external: true },
    { id: 'contact', label: t('nav.contact'), path: 'https://technology.on-point-kw.com/en/contact', external: true }
  ];

  return (
    <header className="main-header">
      <div className="logo-section">
        <img src={logoImg} alt="OnPoint logo" className="logo-img" />
      </div>

      <nav ref={navRef} id="main-navigation" className={`nav-container ${isOpen ? 'open' : ''}`}>
        <div className="nav-inner">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={item.path}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              className={`nav-item ${activeNav === item.id ? 'active' : ''}`}
              onClick={() => {
                setActiveNav(item.id);
                setIsOpen(false);
              }}
            >
              <span>{item.label}</span>
              {item.id === 'services' && <img src={arrowIcon} className="nav-arrow" alt="" />}
            </a>
          ))}
        </div>
      </nav>

      <div className="lang-wrapper" ref={langRef}>
        <button
          type="button"
          className={`lang-pill ${isLangOpen ? 'active' : ''}`}
          aria-expanded={isLangOpen}
          aria-controls="language-menu"
          aria-label={t('aria.language')}
          onClick={() => setIsLangOpen(!isLangOpen)}
        >
          <img src={langIcon} alt="" className="lang-icon" />
          <span className="lang-text">
            {i18n.language === 'ar' ? 'العربية' : 'English'}
          </span>
          <img
            src={arrowIcon}
            alt=""
            className={`lang-arrow ${isLangOpen ? 'rotate' : ''}`}
          />
        </button>

        {isLangOpen && (
          <div className="lang-dropdown" id="language-menu" role="menu">
            <button
              type="button"
              className={`lang-option ${i18n.language === 'ar' ? 'selected' : ''}`}
              onClick={() => changeLanguage('ar')}
              role="menuitem"
            >
              <span>العربية</span>
              {i18n.language === 'ar' && <span className="check-mark">✓</span>}
            </button>
            <button
              type="button"
              className={`lang-option ${i18n.language === 'en' ? 'selected' : ''}`}
              onClick={() => changeLanguage('en')}
              role="menuitem"
            >
              <span>English</span>
              {i18n.language === 'en' && <span className="check-mark">✓</span>}
            </button>
          </div>
        )}
      </div>

      <button
        type="button"
        className={`hamburger ${isOpen ? 'open' : ''}`}
        aria-expanded={isOpen}
        aria-controls="main-navigation"
        aria-label={t('aria.navigation')}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span><span></span><span></span>
      </button>
    </header>
  );
};

export default Header;
